<template>
  <div class="financial">
    <div class="f-content">
      <div class="header-search">
        <custom-search :config="searchConfig" @doSearch="doSearch">
          <template #button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              class="header-search__button"
              @click="onCreateReport"
            >
              {{ $t("financial.newReport") }}
            </el-button>
          </template>
        </custom-search>
      </div>
      <cc-table
        :config="tableConfig"
        :params="searchParams"
        :refeshParams="refresh"
        :showIndex="false"
      ></cc-table>
    </div>
    <div class="f-footer">
      <el-dialog
        width="500px"
        v-if="visibleCreate"
        :title="$t('statistics.dialogTitle')"
        :visible.sync="visibleCreate"
        :close-on-click-modal="false"
        append-to-body
      >
        <create-report
          @cancel="visibleCloseRefresh('visibleCreate')"
          @done="visibleCloseRefresh('visibleCreate')"
        ></create-report>
      </el-dialog>
      <el-dialog
        width="500px"
        v-if="visibleEdit"
        :title="$t('statistics.dialogTitle')"
        :visible.sync="visibleEdit"
        :close-on-click-modal="false"
        append-to-body
      >
        <edit-report
          :value="currentData"
          @cancel="visibleCloseRefresh('visibleEdit')"
          @done="visibleCloseRefresh('visibleEdit')"
        ></edit-report>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 财务费用列表

import moment from "moment";

import CustomSearch from "./components/CustomSearch.vue";
import CreateReport from "./components/CreateReport.vue";
import EditReport from "./components/EditReport.vue";

export default {
  name: "Financial",
  components: { CustomSearch, CreateReport, EditReport },
  i18n: {
    messages: {
      en: { financial: { newReport: "Create Report" } },
      zh: { financial: { newReport: "提报费用" } },
    },
  },
  data() {
    return {
      // 提报费用
      visibleCreate: false,
      visibleEdit: false,

      currentData: {},

      searchParams: {},
      searchConfig: [
        { style: "text", fieldName: "jobId", displayName: "Job ID" },
        {
          style: "text",
          fieldName: "customerName",
          displayName: this.$t("statistics.customerName"),
        },
        {
          style: "month",
          fieldName: "feeMonth",
          displayName: this.$t("statistics.feeMonth"),
        },
      ],
      refresh: "",
      tableConfig: {
        api: "admin/fsb/financial/query",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "product.jobId",
            lable: this.$t("statistics.jobId"),
            minWidth: 100,
          },
          {
            prop: "product.customer.customerName",
            lable: this.$t("statistics.customerName"),
            minWidth: 120,
          },
          {
            prop: "product.productLine",
            lable: this.$t("statistics.productLine"),
            minWidth: 100,
          },
          {
            prop: "product.bootTime",
            lable: this.$t("statistics.startUp"),
            minWidth: 100,
            render: (row) => {
              if (row.product && row.product.bootTime) {
                return moment(row.product.bootTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "warrantyStartTime",
            lable: this.$t("statistics.warranty"),
            minWidth: 180,
            render: (row) => {
              if (
                row.product &&
                row.product.warrantyStartTime &&
                row.product.warrantyEndTime
              ) {
                const sDay = moment(row.product.warrantyStartTime).format(
                  "YYYY-MM-DD"
                );
                const eDay = moment(row.product.warrantyEndTime).format(
                  "YYYY-MM-DD"
                );
                return `${sDay}~${eDay}`;
              }
              // const s = row && row.product && row.warrantyStartTime;
              // const e = row && row.product && row.warrantyEndTime;
              // const sDay =
              //   moment(s).isValid() && moment(s).format("YYYY-MM-DD");
              // const eDay =
              //   moment(e).isValid() && moment(e).format("YYYY-MM-DD");

              // return `${sDay}~${eDay}`;
            },
          },
          {
            prop: "feeMonth",
            lable: this.$t("statistics.feeMonth"),
            minWidth: 100,
            render: (row) => {
              return moment(row.feeMonth).format("YYYY-MM-DD");
            },
          },
          {
            prop: "feeType",
            lable: this.$t("statistics.feeType"),
            render: (row) => {
              return this.$t(`statistics.constants.feeType[${row.feeType}]`);
            },
            minWidth: 80,
          },
          {
            prop: "laborCost",
            lable: this.$t("statistics.laborCost"),
            minWidth: 80,
            render: (rows) => {
              return (rows.laborCost / 100).toFixed(1);
            },
          },
          {
            prop: "travelCost",
            lable: this.$t("statistics.travelCost"),
            minWidth: 80,
            render: (rows) => {
              return (rows.travelCost / 100).toFixed(1);
            },
          },
          {
            prop: "partsCost",
            lable: this.$t("statistics.partsCost"),
            minWidth: 80,
            render: (rows) => {
              return (rows.partsCost / 100).toFixed(1);
            },
          },
          {
            prop: "otherCost",
            lable: this.$t("statistics.otherCost"),
            minWidth: 80,
            render: (rows) => {
              return (rows.otherCost / 100).toFixed(1);
            },
          },
          {
            prop: "salesFee",
            lable: this.$t("statistics.salesFee"),
            minWidth: 80,
            render: (rows) => {
              return (rows.salesFee / 100).toFixed(1);
            },
          },
          {
            prop: "createTime",
            lable: this.$t("statistics.createTime"),
            minWidth: 150,
          },
          { prop: "remark", lable: this.$t("statistics.remark") },
        ],
        buttonsLabel: this.$t("common.opera"),
        buttons: [
          {
            // 编辑
            name: this.$t("common.edit"),
            click: (row) => {
              console.log(row);
              if (row.feeMonth) {
                row.feeMonth = moment(row.feeMonth).format("YYYY-MM-DD");
              }
              this.currentData = row;
              this.visibleEdit = true;
            },
          },
          {
            //   删除
            name: this.$t("common.delete"),
            click: (row) => {
              this.$confirm(this.$t("statistics.tips.deleteMessage"))
                .then(() => {
                  this.deleteReport(row.id).then(() => {
                    this.refresh = Date.now();
                  });
                })
                .catch(() => {});
            },
          },
        ],
      },
    };
  },
  methods: {
    visibleCloseRefresh(name) {
      this[name] = false;
      this.refresh = Date.now();
    },
    doSearch(e) {
      this.searchParams = { ...e };
    },
    // 提报费用
    onCreateReport() {
      this.visibleCreate = true;
    },
    async deleteReport(id) {
      return await this.ccRequest.do(
        "admin/fsb/financial/delete",
        { id },
        "GET"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.financial {
  .header-search__button {
    margin: 10px 0;
  }
}
</style>
